import { Box, Switch, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const VerticalSwitchContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0px',
});

const RotatedSwitch = styled(Switch)(({ $noData }) => ({
  transform: 'rotate(-90deg)',
  margin: '0 -6px',
  ...($noData && {
    '& .MuiSwitch-switchBase': {
      transform: 'translateX(10px)',
    },
    '& .MuiSwitch-thumb': {
      backgroundColor: '#9e9e9e',
    },
  }),
}));

const SwitchLabel = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 600,
  color: theme.palette.text.secondary,
  userSelect: 'none',
  lineHeight: 1,
}));

const LeftLabel = styled(SwitchLabel)({
  marginRight: '-10px',
});

const RightLabel = styled(SwitchLabel)({
  marginLeft: '-10px',
});

/**
 * Вертикальный переключатель для УЗА реле
 * @param {boolean} checked - Состояние переключателя (true = вкл/К)
 * @param {boolean} disabled - Заблокирован ли переключатель
 * @param {boolean} noData - Нет данных (индикатор по центру, цвет #9e9e9e)
 * @param {Function} onChange - Обработчик изменения состояния
 */
export const VerticalSwitch = ({ checked, disabled, noData, onChange, ...props }) => {
  return (
    <VerticalSwitchContainer>
      <LeftLabel>Д</LeftLabel>
      <RotatedSwitch checked={noData ? false : checked} disabled={disabled} $noData={noData} onChange={onChange} {...props} />
      <RightLabel>К</RightLabel>
    </VerticalSwitchContainer>
  );
};
